import React, { useEffect, useState } from "react";
import { useDispatch, connect } from "react-redux";
import analytics from "web/script/analytics/analytics";
import { languageIsEnglish } from "web/script/modules/language";
import environment from "web/script/modules/environment";
import browser from "web/script/utils/browser";
import { gettext } from "web/script/modules/django-i18n";
import { setDesktopBannerVisible } from "web/redux/ducks/app-download-banner";
import userProfiler from "web/script/modules/userprofiler";
import { ProfileProps } from "web/react/components/profile-header/profile-header";
import CookieBanner from "web/react/components/cookie-banner/cookie-banner";
import FollowStickyBanner from "web/react/components/follow-sticky-banner/follow-sticky-banner";
import AppDownloadBannerDesktop from "web/react/components/app-download-banner-desktop/app-download-banner-desktop";
import withReduxProvider from "web/react/redux-provider";
import styles from "./banner-container.css";

interface BannerContainerReduxStateProps {
    feedProfile: ProfileProps;
    showDUBanner: boolean;
    disableDUBanner: boolean;
    desktopAppBannerVisible: boolean;
}

interface BannerContainerProps extends BannerContainerReduxStateProps {
    cookieBanner: {
        cookie_policy_url: string;
    };
}

function mapStateToProps(state): BannerContainerReduxStateProps {
    const {
        profile: feedProfile,
        show: showDUBanner,
        bannerDisable: disableDUBanner,
    } = state.followDesignerBannerReducer;
    const desktopAppBannerVisible = state.appDownloadBannerReducer.desktopBannerVisible;

    return { feedProfile, showDUBanner, disableDUBanner, desktopAppBannerVisible };
}

export function BannerContainer({
    cookieBanner,
    feedProfile,
    showDUBanner,
    disableDUBanner,
    desktopAppBannerVisible,
}: BannerContainerProps): JSX.Element {
    const [isIos, setIsIos] = useState(false);
    const dispatch = useDispatch();

    useEffect(() => {
        setIsIos(browser.ios);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [browser.ios]);

    dispatch(
        setDesktopBannerVisible(
            analytics.getInitialPageType() === "feed" &&
                !!environment.getFeature("mg_app_desktop_banner_feeds") &&
                !feedProfile.brand_ad &&
                !userProfiler.hasAppBannerBeenDismissed() &&
                browser.getViewport() === browser.VIEWPORTS.DESKTOP &&
                !isIos
        )
    );

    const pageSubType = environment.get("pageSubType");
    const enableIosToApp = environment.getFeature("mg_du_banner_ios_to_app");
    const isOnDesignerFeed = pageSubType && pageSubType.startsWith("designer");
    const sendIOSUsersToApp = isIos && enableIosToApp && isOnDesignerFeed;

    let followButtonProps = feedProfile.follow_button
        ? {
              lystId: feedProfile.follow_button.lyst_id,
              isAuthenticated: feedProfile.follow_button.is_authenticated,
              isFollowing: feedProfile.follow_button.is_following,
              description: sendIOSUsersToApp
                  ? feedProfile.follow_button.ios_sticky_description
                  : "",
              notFollowedText:
                  enableIosToApp && isOnDesignerFeed
                      ? // 'Get Designer Updates'
                        gettext("designer_updates.get_designer_updates_btn_text")
                      : feedProfile.follow_button.notfollowed_text,
              profileImage: feedProfile.small_photo_url,
              followedText: feedProfile.follow_button.followed_text,
              designerName: feedProfile.follow_button.designer_name,
              productTaxonomy: feedProfile.follow_button.product_taxonomy,
          }
        : null;

    function onAppDownloadBannerClose(): void {
        dispatch(setDesktopBannerVisible(false));
    }

    return (
        <div className={styles.container}>
            {languageIsEnglish() &&
                !desktopAppBannerVisible &&
                !disableDUBanner &&
                showDUBanner &&
                feedProfile &&
                feedProfile.follow_button &&
                feedProfile.follow_button.is_authenticated != "true" && (
                    <FollowStickyBanner forceDisplay={showDUBanner} {...followButtonProps} />
                )}
            {cookieBanner && (
                <CookieBanner cookiePolicyUrl={cookieBanner.cookie_policy_url} debug={false} />
            )}
            <AppDownloadBannerDesktop
                isOpen={desktopAppBannerVisible}
                onClose={onAppDownloadBannerClose}
                eventLabel={"desktop_banner_feeds"}
            />
        </div>
    );
}

export default withReduxProvider(connect(mapStateToProps)(BannerContainer));
